<template>
  <div class="flex items-center space-x-3">
    <div class="relative">
      <img src="/InvestBuddyLogo.png" alt="InvestBuddy.ai" width="40" height="40" class="rounded-full" />
    </div>
    <div class="flex flex-col">
      <h1 class="text-2xl font-bold text-gray-900 leading-tight">
        <span class="text-blue-600">InvestBuddy</span><span class="text-green-600">.ai</span>
      </h1>
      <span v-if="showTagline" class="text-xs text-gray-500 mt-0.5">Your Intelligent Investment Partner</span>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  showTagline?: boolean
  size?: 'sm' | 'md' | 'lg'
}

withDefaults(defineProps<Props>(), {
  showTagline: true,
  size: 'md'
})
</script>